import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';
@Injectable({
  providedIn: 'root'
})
export class CourseUnitsService {
  list: any = [];
  private unitList = new BehaviorSubject<any>(null);
  constructor(private http: HttpClient) {
    this.list = [];
  }

  // UNITS FUNCTIONS START HERE
  getUnits(id): Observable<any> {
    console.log("Getting courses");
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "course-folder?course=" + id).subscribe((res: any) => {
        console.log("Get Courses Units : ", res);
        // this.unitList = res.data
        this.unitList.next(res.data)
        observer.next(res.data);
        console.log("this.unitList : ", this.unitList);
        observer.complete();
      })
    });
  }

  unitListObservable(): Observable<any> {
    console.log("this.unitList.asObservable() : ", this.unitList);
    return this.unitList.asObservable();
  }

  getFolderWithMaterial(id): Observable<any> {
    console.log("Getting courses");
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "course-folder/submisson?course=" + id).subscribe((res: any) => {
        console.log("Get Courses Units : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }


  addUnit(data): Observable<any> {
    console.log("Adding unitr", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "course-folder", data).subscribe((res: any) => {
        console.log("res of unit added", res);

        observer.next(res.data);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  updateUnit(data): Observable<any> {
    console.log("Adding unit", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "course-folder", data).subscribe((res: any) => {
        observer.next(res.data);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }

  deleteUnit(id) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "course-folder?_id=" + id).subscribe((res: any) => {
        console.log("res of unit deleted", res);

        observer.next(res);
        observer.complete();
      })
    })
  }

  getUnitsMaterial(obj) {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "course-folder/material?materials=" + JSON.stringify(obj)).subscribe((res: any) => {
        console.log("Get Courses Units : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }


}
